import { useState } from "react";
import { createPortal } from "react-dom";
import { MdClose } from "react-icons/md";
import { Blog } from "../../models/blog";
import Button from "../common/Button";

export default function NewsModal(opt: {
  news: Blog;
  isOpen: boolean;
  close: () => void;
}) {
  const [scrolled, setScrolled] = useState(false);

  if (!opt.isOpen) {
    return null;
  }

  return createPortal(
    <div
      className={
        "fixed left-0 top-0 w-screen h-screen flex align-middle justify-center z-40 bg-black bg-opacity-25"
      }
      onClick={() => opt.close()}
    >
      <div className="py-8 flex align-middle justify-center h-full place-items-center">
        <div
          role="alert"
          className="container w-screen max-h-[calc(100vh-5vh)] lg:w-1/2-screen flex align-middle justify-center"
        >
          <div className="relative bg-white dark:bg-white shadow flex justify-center align-middle pt-10 pb-8 rounded-2xl w-full z-50">
            <div
              className="flex flex-col items-center px-4 md:px-12 flex justify-center align-middle w-full"
              onClick={(ev) => {
                ev.stopPropagation();

                return false;
              }}
            >
              <img
                src={opt.news.image}
                alt={opt.news.title}
                className={`h-48 lg:h-64 rounded-2xl w-full object-cover`}
              />
              <p className="text-base sm:text-lg md:text-2xl font-bold md:leading-6 mt-8 lg:mt-8 text-black text-center">
                {opt.news.title}
              </p>
              <div className="text-sm md:text-base lg:text-sm flex flex-row gap-2 mt-2">
                <strong>Wann?</strong>
                {opt.news.date}
              </div>

              <div
                className="my-2 overflow-y-auto max-h-[40vh] relative"
                onScroll={() => setScrolled(true)}
              >
                <div
                  className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-white to-transparent pointer-events-none"
                  style={{ display: scrolled ? "none" : "block" }}
                ></div>
                <p className="text-xs sm:text-sm leading-5 mt-2 sm:mt-4 text-black w-full pb-8">
                  {opt.news.content}
                </p>
              </div>

              <div
                className="flex items-center mt-14 w-full justify-center"
                onClick={() => opt?.close()}
              >
                <Button
                  colors={{ bg: "bg-red", text: "text-white" }}
                  onClick={() => opt.close()}
                >
                  schließen
                </Button>
              </div>
            </div>
            <div
              className="cursor-pointer absolute top-0 right-0 m-3 text-gray-800 dark:text-gray-100 transition duration-150 ease-in-out hover:bg-red-500"
              onClick={() => opt.close()}
            >
              <MdClose
                className={"icon icon-tabler icon-tabler-x text-black"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
